import hooks from './shipments.hooks';
import createSchema from './shipments.schema';

export default (app) => {
  const service = app.service('api/shipments');
  // TODO: Remove this with feathers-dataloader update
  service.options = {
    id: 'id'
  };
  service.schema = createSchema(app);
  service.hooks(hooks);
};
